import { PAYMENT_REVERSAL_RECORD_TYPES, PAYMENT_REVERSAL_TYPES } from '../data/payment-reversal.data';

export type PaymentReversalNavigationDescriptionType<T> = {
  id: T;
  title: string;
  linkPrefix: string;
};

export type PaymentReversalType = typeof PAYMENT_REVERSAL_TYPES[number]['id'];
export type PaymentReversalRecordType = typeof PAYMENT_REVERSAL_RECORD_TYPES[number]['id'];
export type PaymentReversalNavigationTypeRecord = Record<PaymentReversalRecordType, PaymentReversalNavigationDescriptionType<PaymentReversalRecordType>>;
